var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tes-table',{attrs:{"columns":_vm.columns,"row-component":_vm.rowComponent,"data":_vm.invoiceCollection}})}
var staticRenderFns = []

export { render, staticRenderFns }